import Label from "components/Common/Label/Label";
import SearchFilterDropdown from "components/Common/SearchableDropdown/SearchFilterDropdown";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  removeAgencies,
  setAgencies,
  resetAgencies,
  setMultipleAgency,
} from "store/slices/searcSlice";
import { RootState } from "store/store";

const AgencySelect = ({ agencyListData, agencyTypeChangeTrigger }: any) => {
  const agencyParent = useSelector((state: RootState) => state.search.agency_parents);
  const agencyTypes = useSelector((state: RootState) => state.search.agency_types);
  const agencies = useSelector((state: RootState) => state.search.agencies);
  const [agencyOptions, setAgencyOptions] = useState<any>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(resetAgencies());

    // Filter agencyListData based on agencyParent
    const filteredByParent = agencyListData.filter((item: any) => agencyParent.includes(item.name));

    // Extract agencies from the filtered data
    const agenciesData = filteredByParent.map((item: any) => item.agencies).flat();

    // Filter the extracted agencies based on agency_type
    const filteredByType = agenciesData.filter((agency: any) =>
      agencyTypes.includes(agency.agency_type)
    );

    // Create unique agency options
    const uniqueAgencyTypes = Array.from(
      new Map(
        filteredByType.map((agency: any) => [
          agency.agency,
          { label: agency.agency, value: agency.agency },
        ])
      ).values()
    ).sort((a: any, b: any) => a.label.localeCompare(b.label));

    setAgencyOptions([
      { label: "Select All", value: "Select All" },
      { label: "Deselect All", value: "Deselect All" },
      ...uniqueAgencyTypes,
    ]);
  }, [agencyListData, agencyParent, agencyTypes]);

  // Handle the selection of agencies
  const handleSelect = (value: any) => {
    if (value.includes("Select All")) {
      // Select all agencies logic
      const agencyNames = agencyOptions
        .filter((option: any) => option.value !== "Select All" && option.value !== "Deselect All")
        .map((option: any) => option.value);
      dispatch(setMultipleAgency(agencyNames));
    } else if (value.includes("Deselect All")) {
      // Deselect all agencies logic
      dispatch(resetAgencies());
    } else {
      // Handle individual agency selection
      const lastValue = value[value.length - 1];
      dispatch(setAgencies(lastValue));
    }
  };

  // Handle deselecting individual agencies
  const handleDeselect = (value: any) => {
    dispatch(removeAgencies(value));
  };

  useEffect(() => {
    if (agencyTypeChangeTrigger != null) {
      dispatch(resetAgencies());
    }
  }, [agencyTypeChangeTrigger]);


  return (
    <div className="w-full mb-5">
      <Label labelTitle="Select Agency" isHelpIconRequired tooltipText={"This is a tooltip"} />
      <div className="mt-1.5 SelectProject-input">
        <SearchFilterDropdown
          mode="multiple"
          options={agencyOptions}
          onChange={handleSelect}
          defaultValue={agencies}
          handleDeselect={handleDeselect}
          placeholder="Select Agency"
        />
      </div>
    </div>
  );
};

export default AgencySelect;
